export default __webpack_public_path__ + "static/media/API.294090d1.svg";